/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starting_ConversationInputs */

const en_starting_conversation = /** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting conversation...`)
};

const es_starting_conversation = /** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando conversación...`)
};

const fr_starting_conversation = /** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de la conversation...`)
};

const de_starting_conversation = /** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltung wird gestartet...`)
};

const id_starting_conversation = /** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memulai percakapan...`)
};

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const ja_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const zh_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const ar_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const it_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const ru_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const pt_starting_conversation = en_starting_conversation;

/** @type {(inputs: Starting_ConversationInputs) => LocalizedString} */
const ko_starting_conversation = en_starting_conversation;

/**
* | output |
* | --- |
* | "Starting conversation..." |
*
* @param {Starting_ConversationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const starting_conversation = /** @type {((inputs?: Starting_ConversationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starting_ConversationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starting_conversation(inputs)
	if (locale === "es") return es_starting_conversation(inputs)
	if (locale === "fr") return fr_starting_conversation(inputs)
	if (locale === "de") return de_starting_conversation(inputs)
	if (locale === "ja") return ja_starting_conversation(inputs)
	if (locale === "zh") return zh_starting_conversation(inputs)
	if (locale === "ar") return ar_starting_conversation(inputs)
	if (locale === "id") return id_starting_conversation(inputs)
	if (locale === "it") return it_starting_conversation(inputs)
	if (locale === "ru") return ru_starting_conversation(inputs)
	if (locale === "pt") return pt_starting_conversation(inputs)
	return ko_starting_conversation(inputs)
});